import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../components/LocaleProvider';
import { SiteLayout } from '../components/SiteLayout';
import { company } from '../data/company';
export function WholesalePage() {
  const {
    locale
  } = useLocale();
  const t = locale === 'nl' ? {
    eyebrow: 'Professionele klanten',
    title: 'Uw hypermarktpartner voor grotere behoeften.',
    body: `${company.name} combineert het aanbod van een volledige hypermarkt met een team dat zich toelegt op organisaties, retailers en horecaklanten.`,
    cta: 'Zakelijke aanvraag',
    servicesLabel: 'Wat we leveren',
    services: [['Grote volumes & containerorders', 'Van paletleveringen tot volledige containers, met planning per week of per seizoen.'], ['Levering aan bedrijven & kantoren', 'Terugkerende leveringen voor keukens, onthaal en onderhoud.'], ['Hotels & restaurants', 'Verse producten, dranken en horecaformaten met een vast contactpersoon.'], ['Scholen, ziekenhuizen & instellingen', 'Assortimenten op maat van collectiviteiten en aanbestedingen.'], ['Import & export', 'Coördinatie van documenten, transport en levertermijnen.'], ['Distributie in heel België', 'Geplande ritten vanuit Brugge naar uw vestigingen.']],
    stepsLabel: 'Zo werkt het',
    steps: [['Aanvraag', 'U stuurt uw productlijst en volumes door.'], ['Offerte', 'U ontvangt prijzen en levertermijnen binnen één werkdag.'], ['Levering', 'We plannen een vaste rit of een eenmalige zending.']]
  } : {
    eyebrow: 'Business customers',
    title: 'Your hypermarket partner for larger requirements.',
    body: `${company.name} combines the choice of a full hypermarket with a dedicated team for organisations, retailers and hospitality customers.`,
    cta: 'Wholesale enquiry',
    servicesLabel: 'What we supply',
    services: [['Bulk & container orders', 'From pallet deliveries to full containers, planned weekly or seasonally.'], ['Corporate and office supply', 'Recurring deliveries for kitchens, reception and maintenance.'], ['Hotels & restaurants', 'Fresh produce, drinks and hospitality formats with one named contact.'], ['Schools, hospitals & institutions', 'Ranges built for institutional catering and tenders.'], ['Import & export', 'Coordination of documents, transport and lead times.'], ['Nationwide distribution', 'Scheduled runs from Bruges to your locations.']],
    stepsLabel: 'How it works',
    steps: [['Enquiry', 'You send your product list and volumes.'], ['Quotation', 'You receive pricing and lead times within one business day.'], ['Delivery', 'We schedule a standing run or a one-off shipment.']]
  };
  return <SiteLayout data-id="element-256" data-mp="15mc75qp2j4ix">
      <main data-id="element-257" data-mp="15oydjn083dzk">
        <section className="border-b border-ink bg-ink text-paper" data-id="element-258" data-mp="15p6vhtb7d9hm">
          <div className="mx-auto max-w-[1500px] px-5 py-20 lg:px-10 lg:py-28" data-id="element-259" data-mp="1jm3jzo3umevc">
            <p className="font-mono text-[11px] uppercase tracking-label text-cobalt" data-id="element-260" data-mp="1eotvcaoaa78k">
              {t.eyebrow}
            </p>
            <h1 className="mt-8 max-w-[20ch] font-display text-[2.75rem] leading-[0.98] tracking-[-0.03em] sm:text-6xl lg:text-[4.25rem]" data-id="element-261" data-mp="3lg2qzx9xua28">
              {t.title}
            </h1>
            <p className="mt-8 max-w-2xl text-lg leading-8 text-paper/65" data-id="element-262" data-mp="3it0p419h7ux8">
              {t.body}
            </p>
            <Link to="/contact" className="mt-10 inline-block border border-paper bg-paper px-6 py-4 font-mono text-[11px] uppercase tracking-[0.16em] text-ink transition hover:border-cobalt hover:bg-cobalt hover:text-paper" data-id="element-263" data-mp="3mtcbbihhm3at">
              {t.cta}
            </Link>
          </div>
        </section>

        <section className="border-b border-ink" data-id="element-264" data-mp="344e9dyfxt15h">
          <div className="mx-auto max-w-[1500px] px-5 py-16 lg:px-10" data-id="element-265" data-mp="344xj4rvfoj8f">
            <h2 className="font-mono text-[11px] uppercase tracking-label text-cobalt" data-id="element-266" data-mp="392pkechyxhpa">
              {t.servicesLabel}
            </h2>
            <div className="mt-8 border-t border-ink" data-id="element-267" data-mp="3dwk1r9a3pkl7">
              {t.services.map(([title, detail], index) => <article key={title} className="grid gap-4 border-b border-stone py-8 md:grid-cols-[4rem_1fr_1.1fr] md:gap-10" data-id="element-268" data-mp="2le6da0annays" data-mpi={index}>
                  <span className="font-mono text-[11px] text-cobalt" data-id="element-269" data-mp="2dskn3x84n7y9">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <h3 className="font-display text-2xl leading-tight" data-id="element-270" data-mp="23voabfb73znw">
                    {title}
                  </h3>
                  <p className="leading-8 text-ink/65" data-id="element-271" data-mp="1ywuyrsfgyiqd">{detail}</p>
                </article>)}
            </div>
          </div>
        </section>

        <section className="bg-chalk" data-id="element-272" data-mp="1q4j948s6izbg">
          <div className="mx-auto max-w-[1500px] px-5 py-16 lg:px-10" data-id="element-273" data-mp="1q3hxo3794at7">
            <h2 className="font-mono text-[11px] uppercase tracking-label text-cobalt" data-id="element-274" data-mp="1l56ozvsp06ck">
              {t.stepsLabel}
            </h2>
            <ol className="mt-8 grid border-l border-t border-stone md:grid-cols-3" data-id="element-275" data-mp="1g8g5szllcumx">
              {t.steps.map(([title, detail], index) => <li key={title} className="border-b border-r border-stone p-8" data-id="element-276" data-mp="176grif1yo4no" data-mpi={index}>
                  <span className="font-mono text-[11px] text-cobalt" data-id="element-277" data-mp="wkbp5gsa8v3f">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <h3 className="mt-6 font-display text-2xl" data-id="element-278" data-mp="nkew72yv1a2k">{title}</h3>
                  <p className="mt-3 leading-7 text-ink/65" data-id="element-279" data-mp="nm9k8q5fhiav">{detail}</p>
                </li>)}
            </ol>
          </div>
        </section>
      </main>
    </SiteLayout>;
}